import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/baseballcard.css';

// constants
import {
    ALL_BASEBALL_MARKETS,
    WINNER,
    TOTAL_HOME_RUNS,
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER,
    BATTER1_HOME_RUNS,
    BATTER2_HOME_RUNS,
    UNDER_OVER,
    SCORE
} from '../constants/marketTypes';
// helpers
import {getMarketsByCode} from '../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// containers
import Accordion from './accordion';
// components
import HomeRuns from '../components/HomeRuns';


import {showBetSummary} from '../../../helpers/betHelpers';
import OverlayContainer from '../../../containers/overlayContainer';
import {collapseAllMarkets, expandAllMarkets,expandCollapseMarket} from "../actions/marketsActions";
import UnderOverCombine from "../components/underOverCombine";
import WinDrawWin from "../components/winDrawWin";
import FourOddsMarket from '../components/fourOddsMarket';
import CorrectScore from '../components/correctScore';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        betHistoryBets: state.vpp.betHistoryBets,
        baseballMarketsExpanded: state.vpp.baseballMarketsExpanded,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        channelEventBets: state.vpp.channelEventBets
    };
};

class BaseballCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            games: storeData.vpp.games,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            betHistoryBets: storeData.vpp.betHistoryBets,
            baseballMarketsExpanded: storeData.vpp.baseballMarketsExpanded,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                betHistoryBets: storeData.vpp.betHistoryBets,
                baseballMarketsExpanded: storeData.vpp.baseballMarketsExpanded,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                channelEventBets: storeData.vpp.channelEventBets,
            });
        }
    }

    _generateMarketUI(marketCode, selectedEvent, key) {
        let store = this.props.store;
        let marketList = selectedEvent.markets;
        let marketUI;
        let markets = getMarketsByCode(marketCode, marketList);
        let playerOneFullName = this.state.events[this.state.selectedEventIndex].playerOne
        let playerTwoFullName = this.state.events[this.state.selectedEventIndex].playerTwo
        let playerOne = playerOneFullName.split(" ").length>2?playerOneFullName.split(" ")[2]:playerOneFullName.split(" ")[1];
        let playerTwo = playerTwoFullName.split(" ").length>2?playerTwoFullName.split(" ")[2]:playerTwoFullName.split(" ")[1];
        let marketName = getText(marketCode.name, store, [playerOne, playerTwo]);
        playerOne = playerOne.charAt(0)+playerOne.slice(1).toLowerCase()
        playerTwo = playerTwo.charAt(0)+playerTwo.slice(1).toLowerCase()
        let players = {playerOne,playerTwo};
        let content;
        if (markets.length > 0) {
            switch (marketCode) {
                case WINNER:
                    content =  (
                        <WinDrawWin callbacks={() => undefined} markets={markets} store={store}
                                    selectedEvent={selectedEvent} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case SCORE:
                    content = (<CorrectScore callbacks={() => undefined} markets={markets} store={store} key={key} code = {SCORE.code}/>);
                    marketUI = (
                            <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case UNDER_OVER:
                    content =  (
                        <UnderOverCombine callbacks={() => undefined} markets={markets} store={store} key={key} {...players}/>);
                    marketUI = (<Accordion marketLabel={marketName} store={store} key={key} index={key}
                        content={content}/>);
                    break;                
                
                case WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:
                    content =  (
                        <FourOddsMarket callbacks={() => undefined} markets={markets} store={store} key={key} {...players}/>);
                    marketUI = (<Accordion marketLabel={marketName} store={store} key={key} index={key}
                        content={content}/>);

                    break;

                case TOTAL_HOME_RUNS:
                    content = (<HomeRuns callbacks={() => undefined} markets={markets} store={store} key={key} code = {TOTAL_HOME_RUNS.code}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case BATTER1_HOME_RUNS:
                    content = (<HomeRuns callbacks={() => undefined} markets={markets} store={store} key={key} code = {BATTER1_HOME_RUNS.code}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                
                case BATTER2_HOME_RUNS:
                    content = (<HomeRuns callbacks={() => undefined} markets={markets} store={store} key={key} code={BATTER2_HOME_RUNS.code}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;

                default:
                    break;
            }
        }
        return marketUI;
    }
    _toggleMarkets(){
        if (window.innerWidth < 950) {
            this.props.store.dispatch(collapseAllMarkets());
            this.props.store.dispatch(expandCollapseMarket(0))
        }
        else{
            this.props.store.dispatch(expandAllMarkets());
        }
    }
    componentDidMount() {
        this._toggleMarkets();
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        let marketsUI;
        if (selectedEvent !== undefined && selectedEvent.markets && selectedEvent.markets.length) {
            marketsUI = ALL_BASEBALL_MARKETS.map((mkt, index) => this._generateMarketUI(mkt, selectedEvent, index));
        }

        if (showBetSummary(this.props.showLoadingOverlay, selectedGame, selectedEvent, storeData.vpp.noMoreBetsEventList, this.state)) {
            marketsUI = '';
        }
        let overlay = <OverlayContainer store={this.props.store} showLoadingOverlay={this.props.showLoadingOverlay}/>

        return (
            <div id={'football_card'} className={style.mainContainer}>
                <div className={style.footballCard}>{overlay}{marketsUI}</div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(BaseballCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/containers/baseballCard.js